// extracted by mini-css-extract-plugin
export default {"label":"FormLabel_label__GLkoL","asterisk":"FormLabel_asterisk__9zpqZ"};